import { Component } from '@angular/core';
import { ReplenishYourGoodBacteriaComponent } from '@components/consultation-request/upsells/replenish-your-good-bacteria/replenish-your-good-bacteria.component';
import { UpsellSlugs } from '@enums/upsell-slugs';

@Component({
  selector: 'app-replenish-your-good-bacteria-yeast-infection',
  imports: [ReplenishYourGoodBacteriaComponent],
  templateUrl: './replenish-your-good-bacteria-yeast-infection.component.html',
})
export class ReplenishYourGoodBacteriaYeastInfectionComponent {
  public UpsellSlugs: typeof UpsellSlugs = UpsellSlugs;
}
